import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../_redux/student-book-report/StudentBookReportAction";
import * as uiHelpers from "../MonthlyReportUIHelpers";
import { 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { useMonthlyReportUIContext } from "../MonthlyReportUIContext";

export function MonthlyReportTable() {
  // Monthly Report UI Context
  const monthlyReportUIContext = useMonthlyReportUIContext();
  const monthlyReportUIProps = useMemo(() => {
    return {
      queryParams: monthlyReportUIContext.queryParams,
      setQueryParams: monthlyReportUIContext.setQueryParams
    };
  }, [monthlyReportUIContext]);

  // Getting curret state of Monthly Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentBookReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Monthly Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    if (monthlyReportUIProps.queryParams.term) dispatch(actions.getMonthlyReport(monthlyReportUIProps.queryParams));
    return () => dispatch(actions.cleanStudentBookReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthlyReportUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "bookCount",
      text: "Kitap Sayısı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "pageNumberCount",
      text: "Sayfa Sayısı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "date",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: monthlyReportUIProps.queryParams.pageSize,
    page: monthlyReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                monthlyReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}